import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@core/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { ModalTemplateComponent } from '@shared/components/modal-template/modal-template.component';

@Component({
  selector: 'app-account-closed-dialog',
  standalone: true,
  imports: [ModalTemplateComponent, TranslateModule],
  templateUrl: './account-closed-dialog.component.html',
  styleUrl: './account-closed-dialog.component.scss',
})
export class AccountClosedDialogComponent {
  private authService = inject(AuthService);
  private dialogRef = inject(MatDialogRef<AccountClosedDialogComponent>);

  logout(): void {
    this.dialogRef.close();
    this.authService.logout();
  }
}
